import React from "react";
import { useState } from "react";

export default function RegisterForm() {
  const [inputs, setInputs] = useState({});

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(inputs);
  };

  return (
    <div className="registerForm">
      <form onSubmit={handleSubmit}>
        <label>
          Enter your first name:
          <input
            type="text"
            name="firstName"
            value={inputs.firstName || ""}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Enter your last name:
          <input
            type="text"
            name="lastName"
            value={inputs.lastName || ""}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Enter your email:
          <input
            type="email"
            name="email"
            value={inputs.email || ""}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Your telephone number:
          <input
            type="number"
            name="age"
            value={inputs.age || ""}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          <input type="checkbox" />I accept to using data for personalisation
        </label>
        <br />
        <button type="submit">Submit</button>
      </form>
    </div>
  );
}
